export default {
  name: 'AuthInApp',
  path: '/auth',
  beforeEnter: (to, from, next) => {
    if (to.query.type === 'tinkoff') {
      window.location.href = '/redirect.html'
    } else {
      next({ name: 'Page404' })
    }
  },
}
